export default {
    url: 'solutions/casestudy',
    include: ['jp'],
};
